import dayjs from "dayjs";

/**
 * 格式化营业期限展示
 * @param termStart 起始日期
 * @param termEnd 终止日期，空表示长期
 */
export const formatBusinessTerm = (termStart?: string, termEnd?: string): string => {
  const start = termStart || "—";
  const end = termEnd?.trim() ? termEnd : "长期";
  return `${start} 至 ${end}`;
};

/**
 * 格式化日期时间
 * @param value ISO 日期字符串
 */
export const formatDateTime = (value?: string): string => {
  if (!value) return "—";
  const parsed = dayjs(value);
  return parsed.isValid() ? parsed.format("YYYY-MM-DD HH:mm:ss") : value;
};

/**
 * 历史名称列表转展示文案
 * @param names 历史名称数组
 */
export const formatHistoryNames = (names?: string[]): string => {
  if (!names?.length) return "—";
  return names.join("、");
};
